<template>
	<page>
		<module title="基本信息" height="auto">
			<c-detail >
				<c-detail-item label="订单类型" >
					<template v-slot="{data}">
						<span v-if="orderDetail.order_type==1" style="color:#888888">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==2" style="color:#ff00ff">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==3" style="color:#000000">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==4" style="color:#ff0000">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==5" style="color:#707070">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==6" style="color:#aaaa00">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==7" style="color:#0000ff">{{orderTypeName[orderDetail.order_type]}}</span>
						<span v-if="orderDetail.order_type==99" style="color:#0000ff">{{orderTypeName[orderDetail.order_type]}}</span>
					</template>
				</c-detail-item>
				<c-detail-item label="结算状态" >
					<template v-slot="{data}">
						<span v-if="orderDetail.state==1" style="color:darkgray">{{transStateName[orderDetail.state]}}</span>
						<span v-if="orderDetail.state==2" style="color:brown">{{transStateName[orderDetail.state]}}</span>
						<span v-if="orderDetail.state==3" style="color:darkgreen">{{transStateName[orderDetail.state]}}</span>
						<span v-if="orderDetail.state==4" style="color:red">{{transStateName[orderDetail.state]}}</span>
					</template>
				</c-detail-item>

				<c-detail-item label="订单号" >
					{{orderDetail.order_number}}
				</c-detail-item>
				<c-detail-item label="下单用户" >
					{{orderDetail.nick_name}}【{{orderDetail.user_manage_mobilephone}}】
				</c-detail-item>
				<c-detail-item label="下单时间" >
					{{orderDetail.create_date}}
				</c-detail-item>
				<c-detail-item label="支付时间" >
					{{orderDetail.payment_date}}
				</c-detail-item>
				<c-detail-item label="商品数量" >
					{{orderDetail.product_count}}
				</c-detail-item>
				<c-detail-item label="商品金额" >
					￥{{parseFloat(orderDetail.product_money).toFixed(2)}}
				</c-detail-item>
				<c-detail-item label="运费" >
					￥{{parseFloat(orderDetail.logistics_money).toFixed(2)}}
				</c-detail-item>
				<c-detail-item label="其他费用" >
					<span v-if="orderDetail.other_fee"  style="color:#ff00ff">￥{{parseFloat(orderDetail.other_fee).toFixed(2)}}</span>
					<span v-else>--</span>
				</c-detail-item>
			</c-detail>
		</module>
		
		<module title="订单清分信息">
			<div style="padding: 30px 30px 40px;">
				<c-table v-model="settlementList" height="auto" :paging="false" border>
					<c-table-column
						label="费用类型"
						name="fee_name"
						width="90"
					>
						<template v-slot="{data}">
							<span v-if="data.fee_name=='平台盈利' &&data.settle_amount<0" style="color: red">
								平台补贴
							</span>
							<span v-else>{{data.fee_name||'--'}}</span>
						</template>
					</c-table-column>

					<c-table-column
						label="清分状态"
						name="settlement_state"
						width="80"
					>
						<template v-slot="{data}">
							<span v-if="data.settlement_state==1" style="color:darkgray">{{transStateName[data.settlement_state]}}</span>
							<span v-if="data.settlement_state==2" style="color:brown">{{transStateName[data.settlement_state]}}</span>
							<span v-if="data.settlement_state==3" style="color:darkgreen">{{transStateName[data.settlement_state]}}</span>
							<span v-if="data.settlement_state==4" style="color:red">{{transStateName[data.settlement_state]}}</span>
						</template>
					</c-table-column>

					<c-table-column
						label="结算数量"
						name="settled_count"
						width="80"
					>
						<template v-slot="{data}">
							<span>{{data.settled_count||'--'}}</span>
						</template>
					</c-table-column>

					<c-table-column
						label="结算费用"
						name="settled_amount"
						width="100"
					>
						<template v-slot="{data}">
							<span v-if="data.settled_amount<0" style="color: red">
								￥{{parseFloat(Math.abs(data.settled_amount)).toFixed(2)}}
							</span>
							<span v-else>￥{{parseFloat(data.settled_amount).toFixed(2)}}</span>
						</template>
					</c-table-column>

					<c-table-column
						label="清分到账账户"
						name="return_type"
						width="250"
					>
						<template v-slot="{data}">
							<span v-if="data.account_type==1" style="color:forestgreen">
								【平台】
							</span>
							<span v-if="data.account_type==2" style="color:#707070">
								【商家】
							</span>
							<span v-if="data.account_type==1" style="color:forestgreen">{{data.account_name}}</span>
							<span v-if="data.account_type==2" style="color:#707070">{{data.company_name}}
								<span v-if="data.shop_name && data.shop_name!=data.company_name">【{{data.shop_name}}】</span>
							</span>
						</template>
					</c-table-column>

					<c-table-column
						label="预估结算数量"
						name="settle_count"
						width="110"
					>
						<template v-slot="{data}">
							<span>{{data.settle_count||'--'}}</span>
						</template>
					</c-table-column>

					<c-table-column
						label="预估结算费用"
						name="settled_amount"
						width="100"
					>
						<template v-slot="{data}">
							<span v-if="data.settle_amount<0" style="color: red">
								￥{{parseFloat(Math.abs(data.settle_amount)).toFixed(2)}}
							</span>
							<span v-else>￥{{parseFloat(data.settle_amount).toFixed(2)}}</span>
						</template>
					</c-table-column>

					<c-table-column
						label="仅退款数量"
						name="refund_count"
						width="100"
					>
						<template v-slot="{data}">
							<span>{{data.refund_count||'--'}}</span>
						</template>
					</c-table-column>

					<c-table-column
						label="仅退款金额"
						name="refund_amount"
						width="100"
					>
						<template v-slot="{data}">
							<span v-if="data.settle_amount">
								￥{{parseFloat(data.refund_amount).toFixed(2)}}
							</span>
							<span v-else>--</span>
						</template>
					</c-table-column>

					<c-table-column
						label="退货退款数量"
						name="return_count"
						width="100"
					>
						<template v-slot="{data}">
							<span>{{data.return_count||'--'}}</span>
						</template>
					</c-table-column>

					<c-table-column
						label="退货退款金额"
						name="return_amount"
						width="100"
					>
						<template v-slot="{data}">
							<span v-if="data.return_amount">
								￥{{parseFloat(data.return_amount).toFixed(2)}}
							</span>
							<span v-else>--</span>
						</template>
					</c-table-column>

					<c-table-column
						label="关联商家"
						name="shop_name"
						width="250"
					>
						<template v-slot="{data}">
							{{data.company_name||'--'}}
						</template>
					</c-table-column>

					<c-table-column
						label="清分时间"
						name="last_settled_date"
						width="140"
					>
						<template v-slot="{data}">
							{{data.last_settled_date||'--'}}
						</template>
					</c-table-column>

					<c-table-column
						label="创建时间"
						name="create_date"
						width="140"
					></c-table-column>

				</c-table>
			</div>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'order_settlement_detail',
		props: {
			orderNumber: String
		},
		data() {
			return {
				transStateName: {
					4: '取消结算',
					1: '待结算',
					2: '部分结算',
					3: '全部结算'
				},
				state: [{
					name: '待清分',
					value: 1
				},{
					name: '部分结算',
					value: 2
				},{
					name: '全部结算',
					value: 3
				},{
					name: '取消结算',
					value: 4
				}],
				orderTypeName: {
					1: '普通',
					2: '积分',
					3: '赠品',
					4: '砍价',
					5: '预定全款',
					6: '预定定金',
                    7: '定制',
                    18: '搭配购',
                    19: '一元购',
					99: '微信小店'
				},
				orderDetail: {},
				settlementList: [],
				returnList: []
			}
		},
    watch:{//ID变更刷新页面
      orderNumber(){
        this.detail();
      }
    },
		mounted() {
			this.detail();
		},
		computed: {

		},
		methods: {
			detail() {
				this.request({
					url: '/order/settlement/detail',
					data: {order_number: this.orderNumber},
					loading: true,
					success: data => {
						this.orderDetail = data.order_info;
						this.settlementList = data.settlement_info_list;
						this.returnList = data.settlement_return_list;
						console.log(this.settlementList);
						console.log(this.returnList);
					}
				});
			}
		}
	}
</script>